"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generalGlossary = void 0;
exports.generalGlossary = {
    it: {
        monitors: 'Monitor',
        actuators: 'Attuatori',
        goToLualtek: 'Vai a Lualtek',
    },
    en: {
        monitors: 'Monitors',
        actuators: 'Actuators',
        goToLualtek: 'Go to Lualtek',
    },
};
